import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import MiniWidgets from "./MiniWidgets";
import RevenueTab from "./RevenueTab";
import SocketComponent from "../../components/SocketComponent/SocketComponent";
import { getTotalData } from "../../Endpoint/Admin/index";
import { ToastContainer, toast } from "react-toastify";
import "./dashboard.scss";

// Dashboard is always accessible for any logged-in admin/team member
const Dashboard = ({ user }) => {
  const [audio] = useState(
    typeof Audio !== "undefined" &&
      new Audio("https://sevenue.com/files/Chat-Alert.wav")
  );
  const [reports, setReports] = useState([
    { icon: "ri-stack-line", title: "Orders Received", value: "" },
    { icon: "ri-store-2-line", title: "Orders Delivered", value: "" },
    { icon: "ri-briefcase-4-line", title: "Rooms Booked", value: "" },
    { icon: "ri-taxi-line", title: "Transport Requests", value: "" },
  ]);
  const [breadcrumbItems] = useState([
    { title: "Lubumbashi", link: "#" },
    { title: "Dashboard", link: "#" },
  ]);
  const [filter, setFilter] = useState("today");

  const handleNewNotification = (data) => {
    audio.play();
    toast.success(data, {
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const updateReports = (data) => {
    const { orders, deliveries, roomsBooked, transportRequests } = data;

    setReports([
      { icon: "ri-stack-line", title: "Orders Received", value: orders },
      { icon: "ri-store-2-line", title: "Orders Delivered", value: deliveries },
      { icon: "ri-briefcase-4-line", title: "Rooms Booked", value: roomsBooked },
      { icon: "ri-taxi-line", title: "Transport Requests", value: transportRequests || 0 },
    ]);
  };

  const fetchData = (filter) => {
    getTotalData(filter).then((result) => {
      if (result && result.data) {
        updateReports(result.data);
      } else {
        toast.error("Error fetching data");
      }
    });
  };

  useEffect(() => {
    fetchData(filter);
  }, [filter]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItems={breadcrumbItems} />

          {/* Modern Toggle Buttons */}
          <div className="dashboard-filter-toggle mb-4">
            <div className="toggle-wrapper">
              <button
                className={`toggle-btn ${filter === "today" ? "active" : ""}`}
                onClick={() => setFilter("today")}
              >
                <i className="ri-calendar-check-line mr-2"></i>
                Today's Data
              </button>
              <button
                className={`toggle-btn ${filter === "monthly" ? "active" : ""}`}
                onClick={() => setFilter("monthly")}
              >
                <i className="ri-calendar-2-line mr-2"></i>
                This Month's Data
              </button>
            </div>
          </div>

          <Row>
            <Col xl={12}>
              <Row>
                <MiniWidgets reports={reports} />
              </Row>
              {/* revenue Analytics */}
              <RevenueTab />
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
      <SocketComponent onNewNotification={handleNewNotification} />
    </React.Fragment>
  );
};

export default Dashboard;
